// extracted by mini-css-extract-plugin
export default {"flex-container":"SwknWI","flexContainer":"SwknWI","flex-item":"EU8Re0","flexItem":"EU8Re0","button":"PixJud"};